import React from 'react';
import PropTypes from 'prop-types';

const RadioGroupContainer = (props) => {
  const { stacked = false, disabled = false, uiState = {}, children, radioGroupName } = props;
  const childWrapperClasses = stacked ? ' ml-3' : ' border-left border-secondary';
  return (
    <fieldset className="border-0 p-0">
      <legend className={`col-form-label font-weight-bold pt-0${disabled ? ' text-muted' : ''}`}>{radioGroupName}{uiState.required ? ' *' : null}</legend>
      <div className={`${childWrapperClasses}`}>
        {children}
      </div>
    </fieldset>
  );
};

RadioGroupContainer.propTypes = {
  disabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
  radioGroupName: PropTypes.string.isRequired,
  stacked: PropTypes.bool,
  uiState: PropTypes.object,
};

export default RadioGroupContainer;
